import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { automaticService } from "services";
import { logout } from "../logout";

export const getFirmwareUpdates = createAsyncThunk(
  "getFirmwareUpdates",
  async ({ skip, limit }, { rejectWithValue }) => {
    try {
      return await automaticService.get_firmware_updates(skip, limit);
    } catch (error) {
      if (error.message) {
        if (error?.response?.status === 401) {
          logout();
        }
        //No response to request (No service)
        console.log("Internet Disconnected");
      } else {
        console.log(error);
        return rejectWithValue(error);
      }
    }
  }
);

const initialState = {
  result: null,
  loading: false,
  error: null,
};

const firmwareUpdatesSlice = createSlice({
  name: "firmwareUpdates",
  initialState: initialState,
  reducers: {
    clearFirmwareUpdateList: (state, _action) => {
      state.result = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFirmwareUpdates.pending, (state, _action) => {
      state.loading = true;
    });
    builder.addCase(getFirmwareUpdates.fulfilled, (state, action) => {
      state.loading = false;
      state.result = state.result
        ? state.result.concat(action.payload)
        : action.payload;
      state.error = null;
    });
    builder.addCase(getFirmwareUpdates.rejected, (state, action) => {
      state.loading = false;
      state.result = null;
      state.error = action.payload;
    });
  },
});

export const { clearFirmwareUpdateList } = firmwareUpdatesSlice.actions;
export default firmwareUpdatesSlice.reducer;
